// Espelha o backend (Documents.Application/Upload/UploadOptions.cs + S8 Upload__MaxFileSizeBytes).
// Idealmente esses valores viriam de um endpoint /upload/policy; por ora mantemos sincronizados
// manualmente para validar no passo 1 e dar feedback imediato em vez de só falhar no submit.

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024 // 50 MB

export const ALLOWED_MIME_TYPES: ReadonlySet<string> = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
  'image/gif',
  'text/plain',
  'text/csv',
])

// Fallback por extensão quando o browser não detecta um MIME (file.type === '').
// Mantém a lista coerente com ALLOWED_MIME_TYPES.
const EXT_TO_MIME: Record<string, string> = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  txt: 'text/plain',
  csv: 'text/csv',
}

export const ALLOWED_EXTENSIONS = Object.keys(EXT_TO_MIME)

export type FileValidationResult =
  | { ok: true }
  | { ok: false; reason: string }

export function inferMimeType(file: File): string {
  if (file.type) return file.type
  const ext = file.name.match(/\.([^.]+)$/)?.[1]?.toLowerCase()
  return (ext && EXT_TO_MIME[ext]) || ''
}

export function validateFile(file: File): FileValidationResult {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    const limitMb = (MAX_FILE_SIZE_BYTES / 1024 / 1024).toFixed(0)
    const sizeMb = (file.size / 1024 / 1024).toFixed(1)
    return { ok: false, reason: `Tamanho ${sizeMb} MB excede o limite de ${limitMb} MB.` }
  }
  const mime = inferMimeType(file)
  if (!ALLOWED_MIME_TYPES.has(mime)) {
    const shown = mime || 'desconhecido'
    return {
      ok: false,
      reason: `Formato '${shown}' não é aceito. Permitidos: ${ALLOWED_EXTENSIONS.join(', ').toUpperCase()}.`,
    }
  }
  return { ok: true }
}
